import { FormGroup } from '@angular/forms';
import { WorkAddressSearchResultDto } from '@work-frontend-monorepo/work-rest-api';

/** Übernimmt eine Adresse aus der Google-Suche samt Koordinaten in ein Akquiseobjekt-Formular. */
export function applyAddressToProspectForm(formGroup: FormGroup, address: WorkAddressSearchResultDto): void {
  formGroup.patchValue({
    objectStreet: `${address.street ?? ''} ${address.streetNumber ?? ''}`.trim(),
    objectZip: address.zip,
    objectCity: address.city,
    objectCanton: address.canton,
    latitude: address.latitude,
    longitude: address.longitude,
  });
  formGroup.markAsDirty();
  formGroup.markAsTouched();
}
